// src/utils/voiceCallPath.js
//
// Live-call callables (Answer, Invite, Accept, Decline, Cancel) go to a route on
// the one warm `voiceCallPath` function (docs/features/voice_call_path_FEATURE.md).
// Phase 98 S1 (2026-10-28) retired the legacy functions of the same names, so
// there is no flag and no fallback: frontendFlags.voiceCallPath is no longer read.

import { httpsCallableFromURL } from 'firebase/functions'
import { functions } from '@/services/firebaseconfig'

export const VOICE_CALL_PATH = 'voiceCallPath'

/** URL of a voiceCallPath route. The route name is the legacy function name. */
export function voiceCallPathUrl(
  route,
  projectId = functions?.app?.options?.projectId || 'gse-main-site'
) {
  return `https://us-central1-${projectId}.cloudfunctions.net/${VOICE_CALL_PATH}/${route}`
}

/** The callable for a live-call route: always its voiceCallPath route. */
export function liveCallCallable(route) {
  return httpsCallableFromURL(functions, voiceCallPathUrl(route))
}
